import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
`;
export const Container = styled.div `
  height: ${pxToRem(32)};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.sm};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.md};
  transition: box-shadow 175ms ease-in-out;
  box-shadow: none;

  &:focus-within {
    outline: none;
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
  }
`;
export const StyledInput = styled.input `
  padding: 0;
  border: none;
  outline: none;
  height: inherit;
  background-color: transparent;
  color: ${theme.semantic.foreground.primary};
  font-size: ${theme.fontSize.medium};
`;
